import React, {useEffect, useState} from 'react';
import { Formik, Form } from 'formik';
import { FormGroup, Label, Input, Button, Container } from 'reactstrap';
import * as Yup from 'yup';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const AccessoPrenotazione = ({ onValidazione, showAlert }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const initialValues = {
    nome: '',
    cognome: '',
    codicePrenotazione: '',
    captcha: '',
  };

  const validationSchema = Yup.object({
    nome: Yup.string().required('Il nome è obbligatorio'),
    cognome: Yup.string().required('Il cognome è obbligatorio'),
    codicePrenotazione: Yup.string().required('Il codice prenotazione è obbligatorio'),
  });

  const ReCaptchaField = ({ setFieldValue, values }) => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [tokenTimestamp, setTokenTimestamp] = useState(null);
    const TOKEN_VALIDITY_DURATION = 30000;

    useEffect(() => {
      const verify = async () => {
        if (!executeRecaptcha) {
          console.error('reCAPTCHA non è pronto');
          return;
        }
        const now = Date.now();
        if (values.captcha && tokenTimestamp && now - tokenTimestamp < TOKEN_VALIDITY_DURATION) {
          console.log('Token reCAPTCHA ancora valido, nessuna nuova chiamata necessaria.');
          return;
        }
        const token = await executeRecaptcha('prenotazione');
        setFieldValue('captcha', token);
        setTokenTimestamp(now);
        console.log('Token reCAPTCHA aggiornato');
      };
      verify();
      // eslint-disable-next-line
    }, [executeRecaptcha, values.captcha, setFieldValue, tokenTimestamp]);

    return null;
  };

  const handleSubmit = async (values, { setSubmitting, setErrors, resetForm, setStatus, setFieldValue }) => {
    if (!executeRecaptcha) {
      setStatus({ res: false, msg: 'Errore reCAPTCHA. Riprova più tardi.' });
      setSubmitting(false);
      return;
    }

    try {
      const token = await executeRecaptcha('prenotazione');
      setFieldValue('captcha', token);

      const payload = {
        ...values,
        captcha: token,
        'g-recaptcha-response': token,
      };

      showAlert(null);    

      const response = await fetch(process.env.REACT_APP_BASE_SERVER_URI + '/site/verificacodiceprn', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.status !== 200) {
        const msg = await response.text();
        let errmsg = "Si è verificato un problema, riprova più tardi: ";
        if (msg) {
          errmsg = JSON.parse(msg).error;
        }
        showAlert(errmsg);        
        onValidazione(false);
        setFieldValue('captcha', '');
      } else {
        const data = await response.json();
        const { id_voucher, id_associato, data_visita, ora_visita, nome_associato, cognome_associato } = data;
        onValidazione(true, id_voucher, id_associato, data_visita, ora_visita, nome_associato, cognome_associato);
        setFieldValue('captcha', '');
        resetForm();
      }
    } catch (error) {
      let errmsg = "Si è verificato un problema: ";
      if (error.response && error.response.data.error) {
        errmsg += " " + error.response.data.error;
      } else {
        errmsg += " " + error;
      }
      showAlert(errmsg);        
      onValidazione(false);
      setFieldValue('captcha', '');
    } finally {
      setSubmitting(false);
    }
  };

  return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, errors, touched, setFieldValue, isSubmitting }) => (
          <Container className="border">
            <Form>
              <FormGroup>
                <Label for="nome" translate="no">Nome:</Label>
                <Input
                  type="text"
                  name="nome"
                  id="nome"
                  value={values.nome}
                  onChange={handleChange}
                  valid={!errors.nome && touched.nome}
                  invalid={errors.nome && touched.nome}
                />
              </FormGroup>
              <FormGroup>
                <Label for="cognome" translate="no">Cognome:</Label>
                <Input
                  type="text"
                  name="cognome"
                  id="cognome"
                  value={values.cognome}
                  onChange={handleChange}
                  valid={!errors.cognome && touched.cognome}
                  invalid={errors.cognome && touched.cognome}
                />
              </FormGroup>
              <FormGroup>
                <Label for="codicePrenotazione" translate="no">Codice Prenotazione:</Label>
                <Input
                  type="text"
                  name="codicePrenotazione"
                  id="codicePrenotazione"
                  value={values.codicePrenotazione}
                  onChange={handleChange}
                  valid={!errors.codicePrenotazione && touched.codicePrenotazione}
                  invalid={errors.codicePrenotazione && touched.codicePrenotazione}
                />
              </FormGroup>
              <FormGroup>
                {/* Campo captcha invisibile */}
                <ReCaptchaField setFieldValue={setFieldValue} values={values}/>
                <Input
                  type="hidden"
                  name="captcha"
                  value={values.captcha}
                  onChange={handleChange}
                  valid={!errors.captcha && touched.captcha}
                  invalid={errors.captcha && touched.captcha}
                />
              </FormGroup>
              <FormGroup>
                <Button type="submit" color="primary" disabled={isSubmitting}>
                  {isSubmitting ? 'Invio in corso...' : 'Invia'}
                </Button>
              </FormGroup>
            </Form>
          </Container>
        )}
      </Formik>
  );
};

export default AccessoPrenotazione;
